import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { Modal, Button, Card, Row, Col } from "react-bootstrap";
import Select from "react-select";
import SignatureInput from "../sub/SignatureInput";
import Icon from "../sub/Icon";
import CustomLabel from "../sub/CustomLabel";
import { confirmDelivery } from "../../actions/equipments/equipments";
import ArrayUtil from "../../util/ArrayUtil";
import { NotificationManager } from "react-notifications";

class DeliveryConfirmationModal extends React.Component {
  constructor(props) {
    super(props);

    this.techSignatureRef = React.createRef();
    this.clientSignatureRef = React.createRef();

    this.state = {
      techSignature: null,
      clientSignature: null,
      selectedRepOption: null,
      rep_id: "",
      isSubmitting: false,
    };
  }

  closeModal() {
    this.props.close();
  }

  handleConfirm() {
    const { equipment } = this.props;
    const { techSignature, clientSignature, selectedRepOption } = this.state;

    this.setState({ isSubmitting: true });

    const data = {
      equipmentId: equipment._id,
      techSignature,
      clientSignature,
      clientName: selectedRepOption ? selectedRepOption.label : "",
    };

    this.props.onConfirmDelivery(equipment.establishment_id, data, () => {
      NotificationManager.success("La livraison a été confirmée avec succès");
      this.closeModal();
    });
  }

  canConfirm() {
    const { techSignature, clientSignature, selectedRepOption, isSubmitting } = this.state;
    return (
      techSignature &&
      clientSignature &&
      selectedRepOption &&
      !isSubmitting
    );
  }

  getMaterialTypeName() {
    const { equipment, materialsTypes } = this.props;
    const materialType = materialsTypes.find(
      (mt) => mt._id === equipment.material_type_id
    );
    return materialType ? materialType.name : "";
  }

  getBrandName() {
    const { equipment, brands } = this.props;
    const brand = brands.find((b) => b._id === equipment.brand_id);
    return brand ? brand.name : "";
  }

  getModelName() {
    const { equipment, models } = this.props;
    const model = models.find((m) => m._id === equipment.model_id);
    return model ? model.name : "";
  }

  getClients(establishmentId) {
    return this.props.clients
      .filter((c) => c.establishment_id === establishmentId)
      .sort((a, b) => ArrayUtil.ascendingSort(a.name, b.name));
  }

  getRepSelectOptions() {
    const options = [];
    const { equipment } = this.props;
    const establishmentReps = this.getClients(equipment.establishment_id);
    for (const r of establishmentReps) {
      options.push({ value: r._id, label: `${r.name} ${r.first_name}` });
    }
    return options;
  }

  getTechSelectOption() {
    const { user } = this.props;
    return {
      value: user._id,
      label: `${user.name} ${user.first_name}`,
    };
  }

  render() {
    const { equipment } = this.props;
    const { techSignature, clientSignature, selectedRepOption, isSubmitting } = this.state;
    const repSelectOptions = this.getRepSelectOptions();
    const techOption = this.getTechSelectOption();

    return (
      <Modal
        show={true}
        onHide={() => this.closeModal()}
        size="xl"
        backdrop="static"
        keyboard={false}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-warning">
            <Icon icon="truck" className="mr-2" />
            Confirmation de livraison
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-4">
            <h5>Equipement</h5>
            <div className="p-3 bg-light rounded">
              <Row>
                <Col md={4}>
                  <strong>Type :</strong> {this.getMaterialTypeName()}
                </Col>
                <Col md={4}>
                  <strong>Marque :</strong> {this.getBrandName()}
                </Col>
                <Col md={4}>
                  <strong>Modele :</strong> {this.getModelName()}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={4}>
                  <strong>Ref. interne :</strong> {equipment.internal_ref || "-"}
                </Col>
                <Col md={4}>
                  <strong>N° serie :</strong> {equipment.serial_nbr || "-"}
                </Col>
              </Row>
            </div>
          </div>

          <Row>
            <Col sm={6}>
              <Row className="mb-3 d-flex align-items-center">
                <Col>
                  <CustomLabel
                    label={this.props.intl.formatMessage({ id: "Technician" })}
                    htmlFor="tech"
                    labelClassName="col-sm-12 p-0 m-0"
                  />
                </Col>
                <Col>
                  <Select
                    isDisabled={true}
                    placeholder={<FormattedMessage id="Select" />}
                    value={techOption}
                    options={[techOption]}
                  />
                </Col>
              </Row>
              <Card border="dark">
                <Card.Header>
                  <FormattedMessage id="Technician.Signature" />
                </Card.Header>
                <Card.Body className="p-1" style={{ minHeight: "16em" }}>
                  <div
                    id="tech_signature-container"
                    className="max-height-200 min-height-200 text-center mb-2"
                  >
                    <SignatureInput
                      containerId="tech_signature-container"
                      onEnd={(value) => this.setState({ techSignature: value })}
                      ref={this.techSignatureRef}
                    />
                  </div>
                  <Button
                    variant="secondary"
                    className="ml-3"
                    size="sm"
                    onClick={() => {
                      this.techSignatureRef.current.clear();
                      this.setState({ techSignature: null });
                    }}
                    disabled={!techSignature}
                  >
                    <Icon icon="rotate-left" className="mr-2" />
                    <FormattedMessage id="Delete.Signature" />
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            <Col sm={6}>
              <Row className="mb-3 d-flex align-items-center">
                <Col>
                  <CustomLabel
                    label={this.props.intl.formatMessage({ id: "Estab.Rep" })}
                    htmlFor="rep"
                    labelClassName="col-sm-12 p-0 m-0"
                    required
                  />
                </Col>
                <Col>
                  <Select
                    placeholder={<FormattedMessage id="Select" />}
                    noOptionsMessage={() => <FormattedMessage id="No.Result" />}
                    isSearchable={false}
                    onChange={(option) => {
                      this.setState({
                        selectedRepOption: option,
                        rep_id: option.value,
                      });
                    }}
                    value={selectedRepOption}
                    options={repSelectOptions}
                  />
                </Col>
              </Row>
              <Card border="dark">
                <Card.Header>
                  <FormattedMessage id="Estab.Rep.Signature" />
                </Card.Header>
                <Card.Body className="p-1" style={{ minHeight: "16em" }}>
                  <div
                    id="client_signature-container"
                    className="max-height-200 min-height-200 text-center mb-2"
                  >
                    <SignatureInput
                      containerId="client_signature-container"
                      onEnd={(value) => this.setState({ clientSignature: value })}
                      ref={this.clientSignatureRef}
                    />
                  </div>
                  <Button
                    variant="secondary"
                    className="ml-3"
                    size="sm"
                    onClick={() => {
                      this.clientSignatureRef.current.clear();
                      this.setState({ clientSignature: null });
                    }}
                    disabled={!clientSignature}
                  >
                    <Icon icon="rotate-left" className="mr-2" />
                    <FormattedMessage id="Delete.Signature" />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.closeModal()}>
            <FormattedMessage id="Cancel" />
          </Button>
          <Button
            variant="success"
            onClick={() => this.handleConfirm()}
            disabled={!this.canConfirm()}
          >
            {isSubmitting ? (
              <>
                <Icon icon="spinner" className="fa-spin mr-2" />
                Confirmation...
              </>
            ) : (
              <>
                <Icon icon="check" className="mr-2" />
                Confirmer la livraison
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    materialsTypes: state.materialsTypes,
    brands: state.brands,
    models: state.models,
    clients: state.clients,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onConfirmDelivery: (establishmentId, data, successCallback) =>
      dispatch(confirmDelivery(establishmentId, data, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(DeliveryConfirmationModal));
